/*
 * @Author: 李明明
 * @Date: 2022-07-28 09:42:19
 * @LastEditTime: 2022-10-20 10:52:56
 * @LastEditors: 李明明
 * @Description: 微前端配置文件
 * @FilePath: /ykt-micro-main/src/micros/index.js
 * 代码版权方：'政府采购信息网'
 */
// 子应用切换加载进度条
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import Store from "../store";

// 注册微应用主应用
import {
  registerMicroApps,
  start,
  addGlobalUncaughtErrorHandler,
  initGlobalState,
} from "qiankun";
import apps from "./app.js";

// 微应用通信 定义全局状态，并返回通信方法
const globalState = {};
const actions = initGlobalState(globalState);
actions.setGlobalState({
  userInfo: "",
  // 是否显示考试说明弹窗
  showExamExplain: false,
  // 显示考试说明弹窗的信息: 必须包含：signUpUserId  examId
  examExplainInfo: {}
});

registerMicroApps(
  // 微应用路由注册信息
  apps,
  {
    beforeLoad: () => {
      // 加载微应用前，加载进度条
      NProgress.start();
      if (Store.state.userInfo) {
        //  微应用加载检查登录 已登录 子应用直接传参登录
        actions.setGlobalState({ userInfo: Store.state.userInfo });
      }
      actions.onGlobalStateChange((state, prev) => {
        // state: 变更后的状态; prev 变更前的状态
        console.log('===>111', state, prev);
        Store.state.showExamExplain = state.showExamExplain;
        Store.state.examExplainInfo = state.examExplainInfo;
      });
      // 加载微应用前，显示资源加载loading
      Store.state.resourceLoading = true;
      return Promise.resolve();
    },
    afterMount: () => {
      // 加载微应用前，进度条加载完成,资源加载loading隐藏
      NProgress.done();
      Store.state.resourceLoading = false;
      return Promise.resolve();
    },
  }
);

// 启动qiankun的方法
addGlobalUncaughtErrorHandler((event) => {
  console.error(event);
  const { message: msg } = event;
  if (msg && msg.includes("died in status LOADING_SOURCE_CODE")) {
    console.error("微应用加载失败，请检查应用是否可运行");
  }
});

export default start;
export { globalState, actions };
